import { LeaderBoardTableFrame } from "../Components/Frame"
import { extractAllPitcherData, extractPitcherVelocityData, extractPlayByPlayData, resolveSheetDataPitcher } from '../Utils/DataProcess'

const LeaderboardPitcher = ({data, loading}) => {
  //if (!loading) console.log(extractPitcherVelocityData(extractAllPitcherData(data[0].data, data[1].data, data[2].data).table))
  //if (!loading) console.log(resolveSheetDataPitcher(data[2].data, data[1].data))
  return (
    <>
      <div className="wrapper">
        <div className="wrap setin">
          <div className="person_score">
            <div className="title_frame">
              <div className="breadcrumbs2">投手排行 / 測試會排行榜投手</div>
              <div className="title">測試會排行榜投手</div>
            </div>
          </div>
        </div>
      </div>
      <div className="wrapper bg_gray">
        {
          loading? <div className="table_loading">Loading...</div>:
          <LeaderBoardTableFrame type='pitcher' 
          data={
            {
              ...resolveSheetDataPitcher(data[2].data, data[1].data), 
              tradstat: extractPlayByPlayData(data[0].data, data[1].data).pStat,
              ...extractPitcherVelocityData(extractAllPitcherData(data[0].data, data[1].data, data[2].data).table)
            }
          } 
          />
        }
      </div>
    </>
  )
}

export default LeaderboardPitcher